import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LifeProjectBaseEditorComponent} from '../../life-project-base-editor/life-project-base-editor.component';
import {WelfareResultService} from '../../../../../service/welfare-result.service';
import {KeyValueStruct} from '../../../../../class/lifeproject/retirement/epheso/key-value-struct';
import {ApiService} from '../../../../../service/api.service';
import {EphesoAnalisys} from '../../../../../class/lifeproject/retirement/epheso/epheso-analisys';
import {NbDialogService} from '@nebular/theme';
import {EphesoJobChooserComponent} from '../../../../dialog/epheso-job-chooser/epheso-job-chooser.component';
import {PosizionePrevidenzialePregressa} from '../../../../../class/lifeproject/retirement/epheso/posizione-previdenziale-pregressa';
import {NucleoFamigliare} from '../../../../../class/lifeproject/retirement/epheso/nucleo-famigliare';
import {Famigliare} from '../../../../../class/lifeproject/retirement/epheso/famigliare';
import {PersonKind} from '../../../../../class/person-kind.enum';
import {RisultatiPrevidenza} from '../../../../../class/lifeproject/retirement/epheso/risultati-previdenza';
import {Person} from '../../../../../class/person';
import {BoardProject} from '../../../../../class/lifeproject/board-project';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-epheso',
  templateUrl: './epheso.component.html',
  styleUrls: ['./epheso.component.css']
})
export class EphesoComponent extends LifeProjectBaseEditorComponent implements OnInit {

  categories: KeyValueStruct[];
  careers: KeyValueStruct[];

  simError: string;

  @Input()
  result: RisultatiPrevidenza;

  @Input()
  boardProject: BoardProject;

  @Input()
  ephesoAnalysis: EphesoAnalisys;

  @Output()
  ephesoResult = new EventEmitter<RisultatiPrevidenza>();

  @Input()
  person: Person;

  includeFamily: boolean;

  showGAPEditor: boolean;

  totalGap: number;
  retirementDate: any;

  constructor(welfareService: WelfareResultService, private apiService: ApiService, private dialogService: NbDialogService) {
    super(welfareService);
  }

  get family() {
    return this.serviceProject.persons;
  }

  ngOnInit(): void {
    this.apiService.getEphesoCategory().subscribe(value => {
      this.categories = value;
    });

    this.apiService.getEphesoCareers().subscribe(value => {
      this.careers = value;
    });

    if (this.ephesoAnalysis.nucleoFamigliare && this.ephesoAnalysis.nucleoFamigliare.famigliareList) {
      this.includeFamily = this.ephesoAnalysis.nucleoFamigliare.famigliareList.length > 0;
    }
    if (this.boardProject.personRetirement && this.boardProject.personRetirement.expectedMoney > 0) {
      this.showGAPEditor = true;
    }
  }

  openJobChooser(selectJob: PosizionePrevidenzialePregressa, id: number) {
    this.dialogService.open(EphesoJobChooserComponent, {
      context: {
        job: selectJob,
        careers: this.careers,
        categories: this.categories
      }
    }).onClose.subscribe(value => {
      if (id === 0) {
        this.ephesoAnalysis.job1 = value;
      } else {
        this.ephesoAnalysis.job2 = value;
      }
    });
  }

  calcPrevidenza() {
    this.simError = null;
    if (this.includeFamily) {
      const familyCore = new NucleoFamigliare();
      familyCore.famigliareList = [];

      this.family.forEach(person => {
        if (person.name !== this.person.name) {
          const famigliare = new Famigliare();
          famigliare.birthDay = person.birthDay;
          famigliare.rel = person.kind === PersonKind.WIFE || person.kind === PersonKind.HUSBAND ? 'coniuge' : 'figlio';
          famigliare.id = person.name;
          familyCore.famigliareList.push(famigliare);
        }
      });
      this.ephesoAnalysis.nucleoFamigliare = familyCore;
    }

    // force risultati netti
    this.ephesoAnalysis.position.netResult = true;
    this.ephesoAnalysis.position.income.net = true;

    this.apiService.getEphesoResult(this.ephesoAnalysis).subscribe(value => {
      this.result = value;
      this.ephesoResult.emit(this.result);
    }, error => {
      this.simError = error.error.message;
    });
  }

  totalPersonIncome() {
    return this.person.income;
  }

  isJobSelected(job): boolean {
    return job;
  }

  showGapEditor() {
    // get always first resutl for the moment
    const result = this.result.risultatiPensioneObbligatoria.stimaPrevidenzaObbligatoriaList[0];
    const dataAsSting = result.decoSel.toString();

    const tIndex = dataAsSting.indexOf('T', 0);
    const cleanDateString = dataAsSting.substr(0, tIndex).replace(/-/g, '/');

    const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};

    // clean up date for compatibility
    const date: Date = new Date(dataAsSting);

    // reformat date
    this.retirementDate = formatDate(date, 'dd/MM/yyyy', 'en-US', null);

    this.totalGap = Math.round(result.preIncome - result.incomeValue);
    this.showGAPEditor = true;

  }


}
